function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import cn from 'classnames';
import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet';
import Titlebar from '../../pages/dashboard/components/navigation/navbar/Titlebar';
var Page = /*#__PURE__*/ forwardRef(function(props, ref) {
    var id = props.id, children = props.children, className = props.className, title = props.title, noPadding = props.noPadding, _props_showTitlebar = props.showTitlebar, showTitlebar = _props_showTitlebar === void 0 ? true : _props_showTitlebar, _props_showShareLink = props.showShareLink, showShareLink = _props_showShareLink === void 0 ? false : _props_showShareLink;
    var _obj;
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        id: id,
        className: cn('Page', (_obj = {}, _define_property(_obj, className, className), _define_property(_obj, "noPadding", noPadding), _obj))
    }, ref && {
        ref: ref
    }), /*#__PURE__*/ React.createElement(Helmet, null, /*#__PURE__*/ React.createElement("title", null, title ? "LARKI - ".concat(title) : "LARKI")), showTitlebar ? /*#__PURE__*/ React.createElement(Titlebar, {
        showShareLink: showShareLink
    }) : null, children);
});
var PageControl = function(props) {
    var children = props.children, className = props.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('PageControl', _define_property({}, className, className))
    }, children);
};
var PageTop = function(props) {
    var children = props.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "PageTop"
    }, children);
};
var PageTopControl = function(props) {
    var children = props.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "PageTopControl"
    }, children);
};
export var PageBody = function(props) {
    var children = props.children, className = props.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('PageBody', _define_property({}, className, className))
    }, children || null);
};
Page.Top = PageTop;
Page.Top.Control = PageTopControl;
Page.Body = PageBody;
Page.Control = PageControl;
Page.displayName = 'Page';
export default Page;
